import React from "react";
import { Helmet } from "react-helmet";
import { FaBolt } from "react-icons/fa";

const DialysisMarquee = () => {
  return (
    <div>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>
          24/7 Emergency, Dialysis, ICU & Operation Theatre | Columbiaa Hospital Kasturi Nagar
        </title>
        <meta
          name="description"
          content="Columbiaa Hospital, Kasturi Nagar offers 24/7 emergency care, dialysis, ambulance, ICU, CT scan, laboratory, digital X-ray, and operation theatre services. Visit the best multi-speciality hospital near you for advanced treatment."
        />
        <meta
          name="keywords"
          content="hospital near me, 24/7 hospital in Bangalore, Columbiaa Hospital Kasturi Nagar, emergency care Kasturi Nagar, dialysis near me, ICU near me, CT scan near me, operation theatre hospital, ambulance service Bangalore, best hospital near me, multi-speciality hospital, critical care Kasturi Nagar"
        />
        <meta property="og:title" content="Columbiaa Hospital - 24/7 Emergency & Dialysis Services" />
        <meta
          property="og:description"
          content="Get 24/7 emergency, dialysis, ICU, and CT scan services at Columbiaa Hospital, Kasturi Nagar. Your trusted neighbourhood hospital for advanced care."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.columbiaahospital.com" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
      </Helmet>

      {/* Scrolling Marquee Section */}
     <div
  className="w-100 text-white py-2 d-flex align-items-center justify-content-center"
  style={{ backgroundColor: "#1e1c42", overflowX: "hidden" }}
  title="Women's Wellness Week | Columbiaa Hospital | Best Gynaecology Hospital in Kasturi Nagar, Bengaluru"
  aria-label="Women's Wellness Week at Columbiaa Hospital, Best Gynaecology Hospital in Bengaluru"
>
  <h5
    className="fw-bold text-white"
    title="Women's Wellness Week | Women's Health Check-up | Columbiaa Hospital"
  >
    {/* <div style={{ width: "100vw", overflowX: "hidden" }}>
      <marquee
        scrollamount="8"
        style={{ width: "100%" }}
        aria-label="Women's Wellness Week, Gynaecology Consultation, Women's Health Check-up at Columbiaa Hospital"
      >
        <FaBolt style={{ color: "#ffcc00", marginRight: "8px" }} />

        <span style={{ color: "#ffcc00" }}>
          🌸 Women's Wellness Week at Columbiaa Hospital | August 1–7 | 11:00 AM – 1:00 PM | Special Consultation ₹299 | Prior Appointment: +91 85489 79899 | Expert Gynaecology Consultation | Women's Health Check-up | Pregnancy Care | Hormonal Health | Best Women's Hospital in Kasturi Nagar, Bengaluru.
        </span>
      </marquee>
    </div> */}
  </h5>
</div>
    </div>
  );
};

export default DialysisMarquee;
